<template>
  <div class="section login-container">
    <b-form class="center-vertically" @submit="onSubmit">
      <p v-if="show_username_change_info" class="username_change_info">{{ $t('text.username_change_info') }}</p>
      <h1 class="login-header">{{this.$t('text.login')}}</h1>
      <b-form-group id="input-group-1" label="" label-for="input-1">
        <b-form-input
          id="input-1"
          v-model="username"
          type="email"
          required
          class="input"
          :placeholder="$t('text.enter_email')"
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-2" label="" label-for="input-2">
        <b-form-input
          id="input-2"
          type="password"
          autocomplete="on"
          class="input"
          v-model="password"
          required
          :placeholder="$t('text.enter_password')"
        ></b-form-input>
      </b-form-group>

      <p class="error-label" v-if="showError">
        {{ errorText }}
      </p>

      <b-button
        :disabled="!enableSubmitButton"
        v-if="!loading"
        type="submit"
        variant="primary"
        class="login-button"
        >{{this.$t('text.login')}}</b-button
      >
      <div v-if="!loading" style="width:100%;margin-top:20px;">
        <a style="float:left;" href="/register">{{ $t('text.register_user') }}</a>
        <a style="float:right;" href="/reset-password">{{ $t('text.forgot_password') }}</a>
      </div>

      <div v-if="loading" class="loader-container">
        <b-spinner
          variant="dark"
          label="Spinning"
          class="login-loader"
        ></b-spinner>
      </div>
    </b-form>
  </div>
</template>

<script>
import AuthApiService from "../../services/auth_api_service";
import UserApiService from "../../services/user_api_service";
import env from "../../services/env";
import axios from "axios";
import User from "../../models/user"
export default {
  name: "LoginPage",
  data() {
    return {
      username: "",
      password: "",
      loading: false,
      errorText: "",
      showError: false,
      show_username_change_info: false
    };
  },
  watch: {
    username: function() {
      this.showError = false;
    },
    password: function() {
      this.showError = false;
    }
  },
  computed: {
    enableSubmitButton() {
      return this.username && this.password
    }
  },
  methods: {
    async onSubmit(evt) {
      evt.preventDefault();
      this.loading = true;
      this.show_username_change_info = false;

      let params = new URLSearchParams({
        grant_type: "password",
        username: this.username.toLowerCase(),
        password: this.password,
        client_id: env.client_id,
        client_secret: env.client_secret
      });
      try {
        const resp = await AuthApiService.post(params);
        const token = resp.data;
        //this.$store.state.token = token;
        //this.$store.state.token_issued_at = Date.now();
        this.$store.commit("set_token", token);
        this.$store.commit("set_token_issued_at", Date.now());

        axios.defaults.headers.common["Authorization"] =
          "Bearer " + token.access_token;
        try {
          const data = await UserApiService.get_me();
          const auth_user = new User(data.data);
          //this.$store.state.user = auth_user;
          this.$store.commit("set_user", auth_user);
          this.loading = false;
          this.$router.push(this.$route.query.redirect || '/')
        } catch (error) {
          localStorage.clear();
          this.loading = false;
        }
      } catch (err) {
        localStorage.clear();
        if (err.response.status === 400) {
          this.errorText = this.$t("text.wrong_credentials")
          this.show_username_change_info = true;
        } else {
          this.errorText = this.$t("text.something_went_wrong_try_later")
        }
        this.showError = true;
        this.loading = false;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.section {
  height: 100%;
}
.center-vertically {
  margin: 0;
  position: relative;
  top: 40%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.login-container {
  max-width: 550px;
  padding-left: 20px;
  padding-right: 20px;
  margin: auto;
}
.input {
  border-width: 0px;
  border-bottom-width: 1px;
  border-radius: 0px;
}

.login-button {
  margin-top: 20px;
  width: 100%;
}

.login-loader {
  margin-top: 20px;
}

.loader-container {
  width: 100%;
  text-align: center;
}

.login-header {
  margin-bottom: 30px;
}

.error-label {
    color: #dc3545;
    font-size:14px;
    text-align:left;
}

.username_change_info {
    color: #dc3545;
    font-size:14px;
    text-align:left;
}
</style>
